var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-btn",class:[
        'btn-' + _vm.background,
        'btn-' + _vm.size
    ],attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"btn-btn-text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.icon)?_c('i',{staticClass:"btn-btn-icon",class:_vm.icon}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }